export enum LocationErrorMessage {
    FIRST = 'Please enable permission to access your location or type your location in the search box above.',
    SECOND = 'Sorry, we are unable to fetch your current location. Please type your location in the search box above'
}
